export class Tabs {
  tabTitle: string;
}
